export const stripPrefix = (str, prefix) => {
    if (str.startsWith(prefix)) {
        return str.slice(prefix.length);
    }
    return str;
};
